// extracted by mini-css-extract-plugin
export var backgroundTransition = "shared-module--backgroundTransition--WNhGi";
export var sectionTitle = "shared-module--sectionTitle--Ve+X1";
export var swiper = "shared-module--swiper--x2upM";
export var transitionMargin = "shared-module--transitionMargin--3YmCe";